import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from '@mui/material/styles';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: "400px",
    height: "20%",
  },
  '& .MuiDialog-paperCenter': {
    width: "400px",
    minHeight: "450px",
    maxHeight: "600px",
  },
}));

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  height: "45px",
  color: "#9B9B9B",
  fontSize: "18px",
  fontWeight: 600,
  textAlign: "center",
}));

const StyledDialogContentText = styled(DialogContentText)(({ theme }) => ({
  color: "#000000",
  fontSize: "14px",
  height: "-webkit-fill-available",
  textAlign: "center",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  color: "#ffffff",
  backgroundColor: "#106FF9",
  height: "36px",
  borderRadius: "8px",
  margin: "10px",
  minWidth: "90px",
  '&:hover': {
    backgroundColor: "#106FF9",
  },
}));

const CenterOkButton = styled(Button)(({ theme }) => ({
  fontWeight: 600,
  color: "#0014DC",
  backgroundColor: "white",
  height: "36px",
  borderRadius: "4px",
  margin: "-7px auto 10px auto !important",
  minWidth: "90px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "1px #0014DC solid",
}));

const DialogContentStyled = styled(DialogContent)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "auto",
}));

const DownloadButton = styled(Button)(({ theme }) => ({
  color: "#ffffff",
  backgroundColor: "#106FF9",
  height: "36px",
  borderRadius: "8px",
  margin: "10px",
  minWidth: "90px",
  display: "flex-start",
  justifyContent: "center",
  alignItems: "center",
  '&:hover': {
    backgroundColor: "#106FF9",
  },
}));

const CancelButton = styled(Button)(({ theme }) => ({
  color: "#ffffff",
  backgroundColor: "#3C3C3C",
  height: "36px",
  borderRadius: "8px",
  margin: "10px",
  minWidth: "90px",
  '&:hover': {
    backgroundColor: "#3C3C3C",
  },
}));

export interface AlertDialogProps {
  icon?: any;
  title?: string;
  content?: any;
  okButtontext?: string;
  centerOkButtontext?: string;
  cancelButtonText?: string;
  handleOkButton?: any;
  handleCancelButton?: any;
  handleDownloadButton?: any;
}

const AlertDialog: React.FC<AlertDialogProps> = (props: AlertDialogProps) => {
  const [open, setOpen] = React.useState(true);

  function handleOpen() {
    setOpen(false);
    if (props.handleOkButton) props.handleOkButton();
  }

  function handleClose() {
    setOpen(false);
    if (props.handleCancelButton) props.handleCancelButton();
  }

  function handleDownload() {
    setOpen(false);
    if (props.handleDownloadButton) props.handleDownloadButton();
  }

  return (
    <StyledDialog
      open={open}
      // onClose={handleClose}
      classes={{ paper: props.centerOkButtontext ? 'MuiDialog-paperCenter' : 'MuiDialog-paper' }}
      style={{ zIndex: 10000 }}
    >
      {props.icon && <img alt="icon" src={props.icon}></img>}

      {props.title && <StyledDialogTitle id="alert-dialog-title"><b>{props.title}</b></StyledDialogTitle>}

      {props.content && (
        <DialogContentStyled>
          <StyledDialogContentText id="alert-dialog-description">{props.content}</StyledDialogContentText>
        </DialogContentStyled>
      )}

      <DialogActions>
        {props.cancelButtonText && (
          <CancelButton onClick={handleClose}>
            {props.cancelButtonText}
          </CancelButton>
        )}
        {props.handleDownloadButton && (
          <>
            <DownloadButton onClick={handleDownload}>
              View Document
            </DownloadButton>
            <div className="spacer"></div>
          </>
        )}
        {props.okButtontext && (
          <StyledButton onClick={handleOpen}>
            {props.okButtontext}
          </StyledButton>
        )}
        {props.centerOkButtontext && (
          <CenterOkButton onClick={handleOpen}>
            {props.centerOkButtontext}
          </CenterOkButton>
        )}
      </DialogActions>
    </StyledDialog>
  );
};

export default AlertDialog;
